import React, { useRef, useEffect, useContext } from "react";

// Components
import Hero from "../../../components/advanced/hero/Hero";
import ProfileBadge from "../../../components/advanced/profileBadge/ProfileBadge";
import Tooltip from "../../../components/advanced/tooltip/Tooltip";
import SecurityCode from "./components/securityCode/SecurityCode";
import KeyGenerator from "./components/keyGenerator/KeyGenerator";
import DoubleTwoFactorAuth from "./components/doubleTwoFactorAuth/DoubleTwoFactorAuth";

// Libraries
import { Container, MagicModal } from "@hybris-software/ui-kit";
import { useUser, PermissionRoute } from "@hybris-software/use-auth";
import { useNavigate } from "react-router-dom";
import useQuery from "@hybris-software/use-query";

// Svgs
import Copy from "../../../assets/svgs/Copy";

// Hooks
import useText from "../../../hooks/useText";

// Contexts
import { RoutesContext } from "../../../contexts/RoutesContext";

// Utils
import dispatcher from "../../../utils/dispatcher";

// Styles
import Style from "./SecurityView.module.css";
import config from "../../../data/config";
import endpoints from "../../../data/endpoints";

const SecurityView = () => {
  // Hooks
  const copy = useText("copyTooltip");
  const texts = useText("securityView");
  const { userInfo } = useUser();
  const navigate = useNavigate();

  // Refs
  const modalRef = useRef();

  // Contexts
  const { paths } = useContext(RoutesContext);

  // Queries
  const getOTPCodeAPI = useQuery({
    url: endpoints.doubleTwoFactor.SECONDARY_TOTP,
    method: "GET",
    executeImmediately: true,
  });

  useEffect(() => {
    document.title = `${config.PLATFORM_NAME} | ${texts?.pageTitle}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PermissionRoute
      // loader={<Loader />}
      firstApiLoading={getOTPCodeAPI.isLoading}
      minimumLoadingTime={500}
      forLoggedUser={true}
      unAuthorizedAction={() => {
        navigate(paths.auth.login);
      }}
      permissionController={(response) => {
        dispatcher(response.data, navigate, paths);
        return true;
      }}
    >
      <MagicModal ref={modalRef} />

      <Hero>
        <Container>
          <div className={Style.header}>
            <h3 className={Style.title}>{texts?.title}</h3>
            <div className={Style.referral}>
              <div className={Style.referralText}>
                {texts?.cardReferral}{" "}
                {`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
                  "--"}
              </div>

              <Tooltip
                valueToCopy={
                  `${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
                  "--"
                }
                copyIcon={<Copy />}
                textCopy={copy?.copied}
              />
            </div>
          </div>

          <ProfileBadge modalRef={modalRef} />
        </Container>
      </Hero>
      <Container>
        <DoubleTwoFactorAuth getOTPCodeAPI={getOTPCodeAPI} />
        <KeyGenerator />
        <SecurityCode modalRef={modalRef} />
      </Container>
    </PermissionRoute>
  );
};

export default SecurityView;
